<template>
  <div class="Editorial-downloads">
    <ux-atoms-button
      :label="termsAndConditionsTitle"
      @click="toggleModal"
      class="Editorial-downloads__button"
      v-if="termsAndConditionsDescription && termsAndConditionsTitle"
      variant="link"
    />
    <ux-atoms-link
      :href="pdfHref"
      :text="$t('ux.molecules.editorialDownloads.downloadPdf')"
      class="Editorial-downloads__link"
      target="_blank"
      underline
      v-if="pdfHref"
    />

    <Teleport to="#teleports">
      <ux-molecules-modal :event-element="eventElement" button-no-border button-position="right" size="medium" v-model="modalIsOpen">
        <template #header>
          <ux-atoms-typo
            :text="termsAndConditionsTitle"
            as="p"
            class="Editorial-modal__title"
            color="grey-1"
            text-align="center"
            variant="expressive-heading-05"
          />
        </template>

        <ux-atoms-typo :text="termsAndConditionsDescription" as="p" class="Editorial-downloads__modal-text" variant="text-regular" />
      </ux-molecules-modal>
    </Teleport>
  </div>
</template>
<script setup lang="ts">
export interface EditorialDownloadProps {
  pdfHref?: null | string;
  termsAndConditionsDescription?: null | string;
  termsAndConditionsTitle?: null | string;
}

defineProps<EditorialDownloadProps>();

const eventElement = ref<HTMLElement>();
const modalIsOpen = ref<boolean>(false);

const toggleModal = (e: Event) => {
  eventElement.value = e.target as HTMLElement;
  modalIsOpen.value = !modalIsOpen.value;
};
</script>
<style scoped lang="scss">
@use 'EditorialDownloads.scss';
</style>
